module.exports = __webpack_public_path__ + "img/document_b.ef9ca07a.svg";